module.exports = __webpack_public_path__ + "fonts/Merriweather-300-cyrillic-ext7.4adbd98.woff2";